module.exports = __webpack_public_path__ + "assets/images/internal.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/internal.png
// module id = 250
// module chunks = 1